<template>
  <section class="quote-row-section">
    <v-container>
      <h2 v-if="title" class="font-sora quote-row__title">{{ title }}</h2>
      <div class="quote-row" :class="'quote-row--' + quotes.length">
        <quote-block
          v-for="(item, i) in quotes"
          :key="i"
          :quote="item.quote"
          :attribution="item.attribution"
          :role="item.role || ''"
          :eyebrow="item.eyebrow || ''"
          :compact="quotes.length > 1"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import QuoteBlock from '@/components/marketing/QuoteBlock.vue';

/**
 * One or two testimonials side by side, stacking on narrow screens.
 *
 * Several pages carry a main quote plus a supporting one. Two QuoteBlocks in a
 * row rather than stacked keeps the supporting quote reading as support rather
 * than as a second, competing claim.
 */
export default {
  name: 'QuoteRow',
  components: { QuoteBlock },
  props: {
    quotes: {
      type: Array,
      required: true,
      validator: (v) => v.length > 0 && v.length <= 2,
    },
    title: { type: String, default: '' },
  },
};
</script>

<style scoped>
.quote-row-section {
  padding: 8px 0 16px;
}

.quote-row__title {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 24px;
}

.quote-row {
  display: grid;
  gap: 16px;
  margin: 0 auto;
}

.quote-row--1 {
  max-width: 680px;
}

.quote-row--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 980px;
}

@media (max-width: 899px) {
  .quote-row--2 {
    grid-template-columns: minmax(0, 1fr);
    max-width: 680px;
  }
}
</style>
